import { render, staticRenderFns } from "./VaBorderInput.vue?vue&type=template&id=c2f1b050&scoped=true&"
import script from "./VaBorderInput.vue?vue&type=script&lang=js&"
export * from "./VaBorderInput.vue?vue&type=script&lang=js&"
import style0 from "./VaBorderInput.vue?vue&type=style&index=0&id=c2f1b050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1b050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
